import 'typeface-rubik';
import 'typeface-karla';

const defaults = `'Oxygen', 'Lato', -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,Ubuntu,sans-serif`;

export default {
  titleFont: `'Rubik', ${defaults}`,
  bodyFont: `'Karla', ${defaults}`,
};
